import { Controller } from "@hotwired/stimulus"

// The catalogue at /roles and at /interview-questions: a bar of chips over
// one list of cards, after the events calendar.
//
// **Filtering in the browser, never in the query string.** Every card is in
// the HTML the server sent, so a chip hides the cards outside its group
// rather than asking for a page, and each catalogue stays one address
// Cloudflare keeps. A chip is an ordinary link to the group's anchor,
// "#research", which the group's first card carries, so with no script it
// jumps there, and this keeps the same anchor in the address so a filtered
// view can be shared and is restored on load.
//
// /roles has a page per group instead (/roles/areas/<slug>), so there the
// chips are links and nothing is filtered. An old "/roles#automation" link
// goes on to the group's page, found by the chip that answers to the key.
export default class extends Controller {
  static targets = ["chip", "item"]

  connect() {
    if (!this.hasItemTarget) {
      this.forwardOldLink()
      return
    }

    const key = window.location.hash.slice(1)
    this.key = this.chipTargets.some((chip) => chip.dataset.browseKey === key) ? key : "all"
    this.apply()
  }

  choose(event) {
    if (!this.hasItemTarget) return

    event.preventDefault()
    this.key = event.currentTarget.dataset.browseKey
    const address = this.key === "all" ? window.location.pathname : `#${this.key}`
    window.history.replaceState(window.history.state, "", address)
    this.apply()
    this.element.scrollIntoView({ block: "start" })
  }

  forwardOldLink() {
    const key = window.location.hash.slice(1)
    const chip = key && this.chipTargets.find((candidate) => candidate.dataset.browseKey === key)
    if (chip && !chip.getAttribute("href").includes("#")) window.location.replace(chip.href)
  }

  apply() {
    this.chipTargets.forEach((chip) => chip.setAttribute("aria-current", String(chip.dataset.browseKey === this.key)))
    this.itemTargets.forEach((item) => {
      item.hidden = this.key !== "all" && item.dataset.browseKey !== this.key
    })
  }
}
